/*
 * Usage: handle Visitor Location detection and storage
 */
var VisitorLocation = function() {};
VisitorLocation.prototype = {
  maximumAge : 3600000,
  storage_key : 'pos_v3',
  timeout : 15000,
  enableHighAccuracy : true,
  gmap : null,
  gmap_options : {},
  retain_user_zoom : false,// true: avoid modifying map zoom on location change
  success : function(position) {},
  error : function(position_error) {
    console.error(position_error);
  },
  last_position : {},
  getPos : function() {
    var pos = store.get( this.storage_key );
    if(pos == undefined) {
      store.set(this.storage_key, false);
      return false;
    } else {
      return pos;
    }
  },
  setPos : function(pos) {
    var dt = new Date().getTime() + this.maximumAge;
    store.set(this.storage_key, pos, dt);// expires in maximumAge ms
  },
  isUserChecking : function(e) {
    return e && e.type == 'click';
  },
  // call on DOM ready, success_callback
  updateButtons : function(e) {
    var _self = this;
    var had_pos = this.getPos();
    if(had_pos) {
      // we have had a position within the timeout
      $('.btn-location').each( function() {
        _self.showCheck(e, this);
      } );
    }
  },
  showCheck : function(e, elem) {},
  setInput : function(pos) {
    $('input[data-visitor-position]').val( pos.lat + ',' + pos.lng );
  },
  applyPosition : function() {
    var pos = this.getPos();
    if(pos) {
      this.setInput(pos);
    }
    return pos;
  },
  /**
   * @param {function} success
   * @param {function} error
   * @param {object} options
   * @param {object} gmap a Google Map object
   * @param {object} gmap_options options for the Google Map
   * @param {n.Event} e - the optional DOM event that triggered the detect
   */
  detect : function(success, error, options, gmap, gmap_options, e) {
    if(!('geolocation' in navigator)) {
      throw 'Client does not support geolocation';
      return;
    }
    var _self = this;
    _self.gmap = gmap;
    _self.gmap_options = gmap_options;
    _self.success = success;
    _self.error = error;
    var success_callback = function(position) {
      // Firefox/IE: if the location has not changed, do not do anything
      // Chrome does this better, doesn't fire success_callback() if location doesn't change
      var pos = {
        lat : parseFloat(position.coords.latitude),
        lng : parseFloat(position.coords.longitude)
      };
      if(_self.last_position && _self.last_position.lat == pos.lat && _self.last_position.lng == pos.lng) {
        // visitor has not moved from last position recorded, no need to do anything
        return;
      }
      _self.last_position = pos;
      if(_self.gmap) {
        _self.gmap.setCenter( pos );
        if(!_self.retain_user_zoom) {
          if(!'zoom' in _self.gmap_options) {
            _self.gmap_options.zoom = 16;
          }
          _self.gmap.setZoom ( _self.gmap_options.zoom );
        }
      }
      var stored_pos = {
        lat:  Math.round( position.coords.latitude * 100) / 100,
        lng:  Math.round( position.coords.longitude * 100) / 100
      };
      _self.setPos(stored_pos);
      _self.updateButtons(e);
      _self.setInput(stored_pos);
      _self.success(position, _self.gmap);// passed position and map into callback
    };//success

    var error_callback = function(error) {
      _self.error(error, _self.gmap);
    };//error

    // set options and make the call to get the position
    // options
    if(!('enableHighAccuracy' in options)) {
      options.enableHighAccuracy = _self.enableHighAccuracy;
    }
    if(!('timeout' in options)) {
      options.timeout = _self.timeout;//ms
    }
    if(!('maximumAge' in options)) {
      options.maximumAge = _self.maximumAge;//return cached position for 1h in ms
    }
    var id = navigator.geolocation.watchPosition(success_callback, error_callback, options);
  }
};
